import { Collapse, Skeleton } from '@mui/material'
import clsx from 'clsx'
import { useState } from 'react'

import { RotatingChevronIcon } from '@/components/core-v2'

import classes from './orders-accordion-list.module.scss'
import { OrderAccordionSummary } from './orders-accordion-summary'
import { Order, Orders, OrderType } from './orders-types'

const Item = () => (
  <div className={classes.listItem}>
    <Skeleton height="20px" width="250px" />
  </div>
)

const Loading = () => (
  <ul>
    {Array(10)
      .fill(true)
      .map((_, i) => (
        <li key={`item${i * 2}`} className="mb-3">
          <Item />
        </li>
      ))}
  </ul>
)

export interface OrdersAccordionListProps {
  isLoading: boolean
  orders: Orders
  renderOrder: (order: Order) => React.ReactNode
  type: OrderType
}

export const OrdersAccordionList = ({
  isLoading,
  orders,
  renderOrder,
  type
}: OrdersAccordionListProps) => {
  const [expandedOrder, setExpandedOrder] = useState('')

  if (isLoading) return <Loading />

  return orders && orders.length > 0 ? (
    <ul className={classes.root}>
      {orders.map((order: Order) => (
        <li key={order.orderId} className="mb-3">
          <button
            aria-controls="orderAccordion"
            aria-expanded={order.orderId === expandedOrder}
            aria-haspopup="true"
            className={clsx(classes.listItem)}
            id={`accordionButton${order.orderId}`}
            type="button"
            onClick={() => setExpandedOrder(order.orderId === expandedOrder ? '' : order.orderId)}
          >
            <RotatingChevronIcon
              classNames={{ root: classes.chevron }}
              isRotated={order.orderId === expandedOrder}
              rotationDegrees="-90"
            />
            <OrderAccordionSummary order={order} type={type} />
          </button>
          <Collapse in={order.orderId === expandedOrder}>{renderOrder(order)}</Collapse>
        </li>
      ))}
    </ul>
  ) : (
    <section className={classes.empty}>
      <strong>0 orders found</strong>
    </section>
  )
}
